import { render, staticRenderFns } from "./ModalRemoveProfissional.vue?vue&type=template&id=5ef99d12&scoped=true"
import script from "./ModalRemoveProfissional.vue?vue&type=script&lang=ts"
export * from "./ModalRemoveProfissional.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef99d12",
  null
  
)

export default component.exports